module.exports = "<button type=\"Button\" (click)=\"SetHTMLData()\"></button>\n\n<textarea id=\"sample\" >Hi</textarea>\n"